import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FirmwareUpdateStore } from '@store';
import {
  BundleUpdateOtaType,
  OTAVersion,
  VersionListParams,
  XotaOperationStatus,
} from '@vi-iot/client/index';
import { BundleUpdateHelper } from 'src/app/@store/_common/bundle-update-helpers';

@Component({
  selector: 'app-firmware-update-version-list-check',
  templateUrl: './firmware-update-version-list-check.component.html',
  styleUrls: ['./firmware-update-version-list-check.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateVersionListCheckComponent {
  @Input() versionList: VersionListParams;
  @Input() xotaUpdateOperation: XotaOperationStatus;

  protected readonly BundleUpdateOtaType = BundleUpdateOtaType;

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}

  checkIfHaveVersion(otaVersions: OTAVersion[]): boolean {
    return BundleUpdateHelper.checkIfHaveVersion(otaVersions);
  }
}
